import React, { useMemo } from "react"
import { TOnClick } from "../../../../Interfaces/GlobalInterface"
import ModalWithSepLine from "./ModalWithSepLine"
import { useTranslation } from "react-i18next"
import EmailConfigForm from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/Forms/EmailConfigForm"

import PersonalizeForm from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/Forms/PersonalizeForm"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { observer } from "mobx-react"
import SettingsNavigation from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/SettingsNavigation"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import UserFormWelcomeText from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/Forms/UserFormWelcomeText"
import AdditionalSettings from "./AdditionalSettings"

interface Props {
	onClose?: TOnClick<HTMLButtonElement | HTMLElement>
}

const SettingsModal = observer(({ onClose = () => {} }: Props) => {
	const { t } = useTranslation()
	const store = useStore()
	const formStore = useFormStore()

	const wideModal = store.adminSettingsSection === "additional"
	return (
		<ModalWithSepLine
			title={t("rawText.settings")}
			onClose={onClose}
			btnColor={formStore.settingsData.personalize.colorButton}
			width={wideModal ? "1000px" : ""}
		>
			<Whitespace x=".1" />
			<SettingsNavigation />

			{store.adminSettingsSection === "email" && <EmailConfigForm />}
			{store.adminSettingsSection === "personalize" && <PersonalizeForm />}
			{store.adminSettingsSection === "additional" && <AdditionalSettings />}
		</ModalWithSepLine>
	)
})

export default SettingsModal
